import clsx from 'clsx';
/**
 * Thin re-export of clsx so consumers always import from the same place.
 * If we ever need tailwind-merge semantics, we can swap the implementation
 * without changing any callsite.
 */
export function cn(...inputs) {
    return clsx(inputs);
}
//# sourceMappingURL=cn.js.map